var _style, _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgPrinterIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48.1 40.5",
    style: {
      enableBackground: "new 0 0 48.1 40.5"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#137EBB;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.4,10.9h-7V2.1c0-0.6-0.2-1.1-0.6-1.5C32.4,0.2,31.9,0,31.3,0H16.8c-0.6,0-1.1,0.2-1.5,0.6 c-0.4,0.4-0.6,0.9-0.6,1.5v8.8h-7c-1.7,0-3,1.3-3,3v16.3c0,1.7,1.3,3,3,3h7v4.3c0,1.7,1.3,3,3,3h12.7c1.7,0,3-1.3,3-3v-4.3h7 c1.7,0,3-1.3,3-3V13.9C43.4,12.2,42,10.9,40.4,10.9z M17.1,2.4h14v8.5h-14V2.4z M31,37.5c0,0.4-0.3,0.6-0.6,0.6H17.7 c-0.4,0-0.6-0.3-0.6-0.6V24.2h14V37.5z M41,30.2c0,0.4-0.3,0.6-0.6,0.6h-7V23c0-0.7-0.5-1.2-1.2-1.2H15.9c-0.7,0-1.2,0.5-1.2,1.2 v7.9h-7c-0.3,0-0.6-0.3-0.6-0.6V13.9c0-0.3,0.3-0.6,0.6-0.6h32.7c0.4,0,0.6,0.3,0.6,0.6V30.2z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPrinterIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/printer-icon.4ee7ed41.svg";
export { ForwardRef as ReactComponent };